import { defineStore } from "pinia";
import _ from "lodash";
import {
    FetchState, SecureDocumentUploadState, FileUploadCategory, FileUploadResponse, FileUploadCategoryModel
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";

export const initialState: SecureDocumentUploadState = {
    categories: [],
    fetchState: FetchState.Uninitialized
};

export const useSecureDocumentUploadStore = defineStore("secureDocumentUpload", {
    state: (): SecureDocumentUploadState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded
    },
    actions: {
        setCategories (categories: FileUploadCategoryModel[]) {
            this.categories = categories;
        },
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        loadCategories (): Promise<void> {
            if (this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }
            this.setFetchState(FetchState.Loading);
            return UserService.getFileUploadCategories()
                .then(response => {
                    const categories = response.data.categories;
                    this.setCategories(categories);
                    this.setFetchState(FetchState.Loaded);
                })
                .catch(err => {
                    storeHelper.handleError({ error: err, rethrow: true });
                    this.setFetchState(FetchState.Uninitialized);
                });
        },
        upload (args: { category: FileUploadCategory, accountNumber: string, files: File[] })
            : Promise<FileUploadResponse> {
            return new Promise((resolve, reject) => {
                UserService.uploadFiles(args.category, args.accountNumber, args.files)
                    .then(response => {
                        resolve(response.data);
                    }).catch(err => {
                    storeHelper.handleError({ error: err, rethrow: true });
                    reject();
                });
            });
        }
    }
});
